import React, { Component } from "react";
import Cookie from "js-cookie";
import MessageBox from "../UIComponents/MessageBox/MessageBox";
import { Config } from "../../components/config/config";
import LZString from "lz-string";
import NotificationsDropdown from "./Notifications/NotificationsDropdown";

const config = JSON.parse(Config);
const apiInterface = config["api1"];
const baseURL = config["baseURL"];
class Header extends Component {
  constructor(props) {
    super(props);
    const jsonData = Cookie.get("currentUser");
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData =
      decompressedData == "\x00\x00\x00" ? jsonData : decompressedData;
    const user = JSON.parse(decompressedData);
    let userID = user["userId"];
    let givenName = user["givenName"];
    let designation = user["designation"];

    this.state = {
      title: props.title,
      userID,
      givenName,
      designation,
      modalOpen: false,
      message: "",
    };
  }

  handleClose = (e) => {
    this.setState({
      modalOpen: false,
      message: "",
    });
  };

  handleLogout = () => {
    this.setState({
      modalOpen: true,
      message: "Are you sure you want to Signout?",
    });
  };

  componentDidMount() {}
  componentDidUpdate(prevProps) {
    if (prevProps.title !== this.props.title) {
      this.setState({
        title: this.props.title,
      });
    }
  }
  downloadApk(apktype) {
    if (apktype == "android") {
      window.location.href = apiInterface + `/downloadapps?app_type=0`;
    } else {
      window.location.href = apiInterface + `/downloadapps?app_type=1`;
    }
  }

  render() {
    const { userID, givenName, designation, modalOpen, message } = this.state;
    return (
      <>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={true}
            onClose={this.handleClose}
          />
        ) : null}

        <header className="main-header">
          {/* Logo */}
          {/* <a href={`https://aristiwebpp.decathlon.in${localStorage.getItem('DashboardPath')}`} className='logo'> */}
          <a
            href={`${baseURL.slice(0, -1)}${localStorage.getItem(
              "DashboardPath"
            )}`}
            className="logo"
          >
            {/* mini logo for sidebar mini 50x50 pixels */}
            <span className="logo-mini">
              <img
                src="/dist/img/decathlon_favicon.gif"
                width={25}
                alt="mini-logo"
              />
            </span>
            {/* logo for regular state and mobile devices */}
            <span className="logo-lg">
              <img
                src="/dist/img/logodecathwhite.png"
                width={140}
                alt="logo-decathlon"
              />
            </span>
          </a>
          {/* Header Navbar: style can be found in header.less */}
          <nav className="navbar navbar-static-top">
            {/* Sidebar toggle button*/}
            <a
              href="#"
              className="sidebar-toggle"
              data-toggle="push-menu"
              role="button"
            >
              <span className="sr-only">Toggle navigation</span>
            </a>
            <div style={{ height: "10px" }}></div>
            <span
              className="subheader-main"
              style={{ textTransform: "capitalize" }}
            >
              {this.state.title}
            </span>
            <div className="navbar-custom-menu">
              <ul className="nav navbar-nav">
                <li className="playstore-logo">
                  <a>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.downloadApk("android");
                      }}
                    >
                      <img
                        src={require("../../assets/playstore.png")}
                        style={{ width: "30pxpx", height: "30px" }}
                      />
                    </span>
                  </a>
                </li>
                <li className="playstore-logo">
                  <a>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.downloadApk("ios");
                      }}
                    >
                      <img
                        src={require("../../assets/apple.png")}
                        style={{ width: "30px", height: "30px" }}
                      />
                    </span>
                  </a>
                </li>
                <li className="bell-notification-icon">
                  <NotificationsDropdown />
                </li>

                {/* Messages: style can be found in dropdown.less*/}

                {/* User Account: style can be found in dropdown.less */}
                <li className="dropdown user user-menu">
                  <a
                    href="#"
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    <span className="hidden-xs">
                      {givenName} <span className="caret"></span>
                    </span>
                  </a>
                  <ul className="dropdown-menu">
                    {/* User image */}
                    <li className="user-header">
                      <p>User Id - {userID}</p>
                      <p>Designation - {designation}</p>
                    </li>
                    {/* Menu Body */}

                    {/* Menu Footer*/}
                    <li className="user-footer">
                      <div className="pull-right">
                        <button
                          type="button"
                          className="btn btn-secondary deca-btn-yellow"
                          onClick={this.handleLogout}
                        >
                          Sign out
                        </button>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </header>
      </>
    );
  }
}

export default Header;
